<script setup lang="ts">
import ClockSolidIcon from '@/assets/icons/ClockSolidIcon.vue';

defineProps<{
  openCount: number;
  totalCount: number;
}>();
</script>

<template>
  <span class="status-chip bg-surface-warning text-on-tint">
    <ClockSolidIcon class="size-icon-smd shrink-0" aria-hidden="true" />
    <span class="lowercase">{{ openCount }} / {{ totalCount }} {{ $t('performanceAssessmentEntry.open') }}</span>
  </span>
</template>
